module.exports = __webpack_public_path__ + "media/images/mailer/security-48-primary-f59ef4cc43b9e7d4f9afb9df7f82c35f.png";